
export default {
  namespaced: true,
  state: {
    serverJDs: [],
    recommendedJDs: [],
    filteredJDs: [],
    serverPage: 1,
    serverTotalPages: 1,

    serverSearchConditions: {
      jdSearch: '',
      searchType: 'all',
    },

    preservedState: {
      scrollPosition: 0,
    },
  },

  getters: {
    getPreservedState: (state) => state.preservedState,
    getServerPage: (state) => state.serverPage,
    getServerTotalPages: (state) => state.serverTotalPages,
  },

  mutations: {
    setPreservedState(state, payload) {
      state.preservedState = payload;
    },
    setServerJds(state, payload) {
      state.serverJDs = payload;
    },
    setRecommendedJds(state, payload) {
      state.recommendedJDs = payload;
    },
    setFilteredJds(state, payload) {
      state.filteredJDs = payload;
    },
    setServerSearchConditions(state, { jdSearch, searchType }) {
      state.serverSearchConditions = { jdSearch, searchType };
    },
    setServerPage(state, payload) {
      state.serverPage = payload;
    },
    setServerTotalPages(state, payload) {
      state.serverTotalPages = payload;
    },
    clearProfileJDDatas(state) {
      state.serverJDs = [];
      state.filteredJDs = [];
      state.recommendedJDs = [];
      state.serverPage = 1;
      state.serverSearchConditions = {
        jdSearch: '',
        searchType: 'all',
      };
    },
  },
};
